var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPriceTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/price-tag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.7813 3.448C16.2814 2.94787 15.6032 2.66682 14.896 2.66667H5.33333C4.62609 2.66667 3.94781 2.94762 3.44772 3.44772C2.94762 3.94781 2.66667 4.62609 2.66667 5.33333V14.896C2.66682 15.6032 2.94787 16.2814 3.448 16.7813L15.0533 28.3867C15.6594 28.9889 16.479 29.3268 17.3333 29.3268C18.1877 29.3268 19.0073 28.9889 19.6133 28.3867L28.3867 19.6133C28.9889 19.0073 29.3268 18.1877 29.3268 17.3333C29.3268 16.479 28.9889 15.6594 28.3867 15.0533L16.7813 3.448Z",
    stroke: "#FD2D23",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 11.3333C10.7364 11.3333 11.3333 10.7364 11.3333 10C11.3333 9.26362 10.7364 8.66667 10 8.66667C9.26362 8.66667 8.66667 9.26362 8.66667 10C8.66667 10.7364 9.26362 11.3333 10 11.3333Z",
    fill: "#FD2D23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPriceTag);
export default __webpack_public_path__ + "static/media/icon_price_tag.12aae6a7c374bd13678ce6cfe318a836.svg";
export { ForwardRef as ReactComponent };